module.exports = __webpack_public_path__ + "media/impact4.543ab223.webm";